
import { parseTime } from './sunrise'

/**
 * 将ISO时间字符串转换为北京时间格式
 * @param {string|number|Date} dateInput - 日期输入，可以是ISO字符串、时间戳、Date对象
 * @returns {string} 格式化后的北京时间，如 '2026-09-30 17:28:26'，如果输入无效则返回空字符串
 */
export function formatToBeijingTime(dateInput) {
    if (dateInput === '' || dateInput === null || dateInput === undefined) {
        return '';
    }
    
    if (typeof dateInput === 'number' && isNaN(dateInput)) {
        return '';
    }
    
    try {
        let date;
        
        if (dateInput instanceof Date) {
            date = dateInput;
        } else if (typeof dateInput === 'number') {
            date = new Date(dateInput);
        } else if (typeof dateInput === 'string') {
            date = new Date(dateInput);
        } else {
            return '';
        }
        
        if (isNaN(date.getTime())) {
            console.warn('无效的日期格式:', dateInput);
            return '';
        }
        
        // 直接使用本地时间方法，因为浏览器已自动完成UTC→北京时间的转换
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    } catch (error) {
        console.error('日期格式化失败:', error);
        return '';
    }
}

/**
 * 格式化日期时间，如果无效则返回指定默认值
 * @param {string|number|Date} dateInput - 日期输入
 * @param {string} defaultValue - 默认值，默认为空字符串
 * @returns {string} 格式化后的日期或默认值
 */
export function formatToBeijingTimeWithDefault(dateInput, defaultValue = '') {
    const result = formatToBeijingTime(dateInput);
    return result || defaultValue;
}


/**
 * 表格时间格式化
 */
export function formatDate(cellValue) {
  if (cellValue == null || cellValue == "") return "";

  console.log("原始值:", cellValue, "类型:", typeof cellValue);

  let time;

  // 如果已经是数字类型，直接使用
  if (typeof cellValue === 'number') {
    time = cellValue;
  } else {
    // 如果是字符串，尝试转换
    time = parseFloat(cellValue);
  }

  console.log("转换后的时间戳:", time);

  // 判断时间戳长度
  const timestampStr = String(time);
  console.log("时间戳字符串:", timestampStr, "长度:", timestampStr.length);

  // 如果是10位秒级时间戳，转换为毫秒
  if (timestampStr.length === 10) {
    time = time * 1000;
  }
  // 13位毫秒时间戳直接使用
  // 其他情况也直接使用，让 Date 构造函数处理

  console.log("最终时间戳:", time);

  var date = new Date(time)
  console.log("创建的日期对象:", date, "是否有效:", !isNaN(date.getTime()));

  if (isNaN(date.getTime())) {
    console.error("无效的日期:", cellValue, "转换后:", time);
    return "无效日期";
  }

  var year = date.getFullYear()
  var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()

  const formatted = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
  console.log("格式化结果:", formatted);
  return formatted;
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
 export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}
// 用于将ISO日期时间字符串转换为北京时间字符串
export function isoDateString2BeijingDateString (isoDateString) {
  // 解析ISO日期时间字符串为Date对象
  const date = new Date(isoDateString);

  // 转换为UTC时间
  //console.log("UTC时间:", date.toISOString()); // 输出UTC时间，用于验证转换

  // 转换为北京时间（CST，UTC+8）
  // 注意：直接使用new Date()加上时差可能会导致不准确，因为Date对象会自动根据本地时区进行调整。
  // 因此，我们可以手动调整时区差值。
  let beijingTime = new Date(date.getTime() + 8 * 60 * 60 * 1000); // 加8小时

  //console.log("北京时间:", beijingTime.toISOString()); // 输出北京时间
  return beijingTime.toISOString().slice(0, 19).replace('T',' '); // 输出北京时间字符串，精确到秒
}

// 格式化日期时间字符串
export function formatDatefromTimestamp(timestamp) {
  if (timestamp == null || timestamp === "") return "";

  let time = parseFloat(timestamp);

  console.log("原始时间戳:", timestamp, "解析后:", time);

  // 如果是10位或带小数的秒级时间戳，转换为毫秒
  if (('' + time).length <= 13 && time > 1000000000) {
    time = time * 1000;
  }

  console.log("转换后的毫秒时间:", time);

  // 使用多种方式创建日期对象，避免溢出
  let date;
  if (time > 1000000000000) { // 已经是毫秒
    date = new Date(time);
  } else {
    date = new Date(time * 1000);
  }

  console.log("创建的日期对象:", date);

  if (isNaN(date.getTime())) {
    console.error("formatDatefromTimestamp: 无效的日期:", timestamp);
    return "无效日期";
  }

  let year = date.getFullYear();
  let month = ('0' + (date.getMonth() + 1)).slice(-2);
  let day = ('0' + date.getDate()).slice(-2);
  let hours = ('0' + date.getHours()).slice(-2);
  let minutes = ('0' + date.getMinutes()).slice(-2);
  let seconds = ('0' + date.getSeconds()).slice(-2);
  return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
}


export function formatArrayDate(dateArray) {
  if (!Array.isArray(dateArray) || dateArray.length < 6) {
    return 'Invalid Date'
  }

  const [year, month, day, hour, minute, second] = dateArray

  // 格式化为：2025-07-26 23:17:16
  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')} ${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}:${String(second).padStart(2, '0')}`
}

// 通用的日期格式化函数
export function formatLocalDateTime(value) {
  if (!value) return ''

  if (Array.isArray(value)) {
    return formatArrayDate(value)
  }

  // 其他格式的处理...
  try {
    const date = new Date(value)
    if (isNaN(date.getTime())) return 'Invalid Date'

    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')
    const seconds = String(date.getSeconds()).padStart(2, '0')

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
  } catch (e) {
    return 'Invalid Date'
  }
}